import React from "react"
import ButtonMaterial from "@material-ui/core/Button"
import styled from "styled-components"

export const StyledButton = styled(ButtonMaterial)`
  height: 33px;
  border-radius: 4px;
  margin: 8px;
  min-width: 90px;
  transition: all 400ms ease;
  &.btn-primary {
    background-color: var(--primaryColor);
    color: var(--white);
    border: 1.5px solid var(--primaryColor);

    &.Mui-disabled {
      border: 1.5px solid #ccc;
      color: #000;
      background-color: #ccc;
    }
  }

  &.btn-secondary {
    background-color: transparent;
    color: var(--primaryColor);
    border: 1.5px solid var(--primaryColor);

    &.Mui-disabled {
      border: 1.5px solid #ccc;
      color: #ccc;
    }
  }

  &:hover {
    transform: scale(1.03);
  }
  &:active {
    transform: scale(0.9);
  }
`
const ButtonUI = (props) => {
  const { title = "SAVE", typeView = "primary", ...restProps } = props || {}
  return (
    <StyledButton className={`btn-${typeView}`} {...restProps}>
      {title}
    </StyledButton>
  )
}

export { ButtonUI }
export default ButtonUI
